import { useEffect, useRef } from "react";

export function useReveal(options = {}) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, ...options }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return ref;
}

export function useCountUp(target, durationMs = 2000, start = false) {
  const ref = useRef(null);
  useEffect(() => {
    if (!start) return;
    const el = ref.current;
    if (!el) return;
    const startTs = performance.now();
    let raf;
    const tick = (now) => {
      const p = Math.min(1, (now - startTs) / durationMs);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.floor(target * eased).toLocaleString();
      if (p < 1) raf = requestAnimationFrame(tick);
      else el.textContent = target.toLocaleString();
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, durationMs, start]);
  return ref;
}
